var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / AL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-AL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#EE343C",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4739721,4.47397208 C12.2122045,4.21220453 11.7547607,4.16349284 11.4534912,4.36433919 L10.5465088,4.96899414 C10.2446803,5.17021312 10.2654394,5.46605301 10.5918198,5.62924321 L12.0748469,6.37075679 C12.4016999,6.5341833 12.6666667,6.96257655 12.6666667,7.33333333 L12.6666667,7.33333333 C12.6666667,7.70152317 12.3707568,8 12,8 L12,8 C11.6318102,8 11.067894,7.86728032 10.7415136,7.70409012 L9.25848643,6.96257655 C8.9316334,6.79915003 8.45833333,6.875 8.20033137,7.13300196 L7.79966863,7.5336647 C7.54211876,7.79121458 7.59877268,8.13271968 7.9251531,8.29590988 L9.40818024,9.03742345 C9.73503327,9.20084997 9.75476074,9.49682617 9.45349121,9.69767253 L8.54650879,10.3023275 C8.24468032,10.5035465 8.28419813,10.7235063 8.6585594,10.7983785 L10.6747739,11.2016215 C11.0384862,11.2743639 11.0872396,11.5179036 10.7936935,11.7380632 L9.20630646,12.9286035 C8.90827163,13.1521296 8.96257655,13.3333333 9.33333333,13.3333333 L9.33333333,13.3333333 C9.70152317,13.3333333 10.28538,13.2619883 10.6455256,13.1719519 L12.0211411,12.8280481 C12.377655,12.7389196 12.5031738,12.9119059 12.3023275,13.2131755 L11.6976725,14.1201579 C11.4964535,14.4219863 11.6284402,14.6666667 11.9993044,14.6666667 L12.6673623,14.6666667 C13.0351679,14.6666667 13.4260305,14.9447581 13.5442708,15.2994792 L13.7890625,16.0338542 C13.9055601,16.3833469 14.0926971,16.3885752 14.2109375,16.0338542 L14.4557292,15.2994792 C14.5722267,14.9499865 14.9617736,14.6666667 15.3326377,14.6666667 L16.0006956,14.6666667 C16.3685013,14.6666667 16.5031738,14.4214274 16.3023275,14.1201579 L15.6976725,13.2131755 C15.4964535,12.911347 15.6187134,12.7380117 15.9788589,12.8280481 L17.3544744,13.1719519 C17.7109883,13.2610804 18.2959099,13.3333333 18.6666667,13.3333333 L18.6666667,13.3333333 C19.0348565,13.3333333 19.0872396,13.148763 18.7936935,12.9286035 L17.2063065,11.7380632 C16.9082716,11.5145371 16.9508648,11.2764937 17.3252261,11.2016215 L19.3414406,10.7983785 C19.7051529,10.7256361 19.7547607,10.5031738 19.4534912,10.3023275 L18.5465088,9.69767253 C18.2446803,9.49645355 18.2654394,9.20061366 18.5918198,9.03742345 L20.0748469,8.29590988 C20.4016999,8.13248337 20.4583333,7.79166667 20.2003314,7.5336647 L19.7996686,7.13300196 C19.5421188,6.87545209 19.067894,6.79938634 18.7415136,6.96257655 L17.2584864,7.70409012 C16.9316334,7.86751663 16.3707568,8 16,8 L16,8 C15.6318102,8 15.3333333,7.70409012 15.3333333,7.33333333 L15.3333333,7.33333333 C15.3333333,6.9651435 15.6045736,6.53104655 15.9360237,6.36532148 L18,5.33333333 L16.5465088,4.36433919 C16.2446803,4.16312021 15.785965,4.21403503 15.5260279,4.47397208 L14.4739721,5.52602792 C14.2122045,5.78779547 13.785965,5.78596497 13.5260279,5.52602792 L12.4739721,4.47397208 Z",
    id: "Line",
    fill: "#262626",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.f4bedc58c681f1c760be2af16065da4c.svg";
export { ForwardRef as ReactComponent };